import { useForm } from 'react-hook-form'
import { FormControl, Input, IconButton, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'

export interface SearchInputProps {
  placeholder?: string
  // onSearch: (query: string | null) => void
}

export function SearchBar({ placeholder }: SearchInputProps) {
  const { reset } = useForm()

  const onClear = () => {
    reset()
  }

  return (
    <FormControl variant='outlined' sx={{ display: 'flex', mr: 2 }}>
      <Input
        size='small'
        startAdornment={
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        }
        endAdornment={
          <IconButton type='reset' aria-label='reset' onClick={() => onClear()}>
            <ClearIcon />
          </IconButton>
        }
        inputProps={{
          'aria-label': 'leit',
          role: 'searchbox',
          placeholder: placeholder,
        }}
      />
    </FormControl>
  )
}
